import { render } from "./ItemTitle.vue?vue&type=template&id=26b6888c&scoped=true"
import script from "./ItemTitle.vue?vue&type=script&lang=js"
export * from "./ItemTitle.vue?vue&type=script&lang=js"

import "./ItemTitle.vue?vue&type=style&index=0&id=26b6888c&scoped=true&lang=css"

import exportComponent from "/home/jenkinsx/workspace/build-dc-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b6888c"]])

export default __exports__